import { Group } from 'src/design/atoms/Group';
import { Text } from 'src/design/atoms/Text';
import React from 'react';
import { formatHours } from 'src/utils';
import type { IPayCodeHours } from 'src/app/timesheets/buildTimesheetWeekHours';

export interface IPayCodeHoursSummaryProps {
  hoursByPayCode: IPayCodeHours[];
}

/** @registry Row of "PayCodeName: Hours" totals, one per pay code, formatted to 2 decimals. */
export const PayCodeHoursSummary: React.FC<IPayCodeHoursSummaryProps> = ({
  hoursByPayCode,
}) => {
  return (
    <Group justify="center" gap="lg">
      {hoursByPayCode.map((item) => (
        <Text key={item.payCodeId} size={'lg'} fw={500} c="bright">
          {item.payCodeName}: {formatHours(item.hours)}
        </Text>
      ))}
    </Group>
  );
};
